<template>
  <div
    id="detect"
    class="ads ad adsbox doubleclick ad-placement carbon-ads"
  ></div>

  <notifications />
  <router-view></router-view>
  <system-messages />
  <resume-preview-modal />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import './css/index.css'
import '@stripe/stripe-js'
import Notifications from '@/components/common/notifications/Notifications.vue'
import { NOTIFICATIONS } from '@/constants'
import notificationMutations from '@/store/notificationModule/mutationTypes'
import { useRouter, useRoute } from 'vue-router'
import { APP_EVENTS } from '@/constants'
import trackPageView from '@/router/middleware/analytics/after/trackPageView'
import SystemMessages from '@/components/ui/AppSnackBar/AppSnackBar.vue'
import ResumePreviewModal from '@/components/resume/ResumePreviewModal.vue'

export default defineComponent({
  name: 'App',
  components: { Notifications, SystemMessages, ResumePreviewModal },
  setup() {
    const { commit } = useStore()
    const router = useRouter()
    const route = useRoute()

    // call middleware manually to track initial page view
    // but only if we're headed to app root
    if (window.location.pathname === '/') {
      trackPageView(route)
    }

    document.addEventListener(APP_EVENTS.SESSION_EXPIRED, () => {
      commit(
        notificationMutations.ADD.NAMESPACED,
        NOTIFICATIONS.SESSION_EXPIRED
      )

      router.push({
        name: 'logIn',
        query: { redirect: window.location.href },
      })
    })
  },
})
</script>

<style>
html,
body {
  @apply bg-backdrop;
}
iframe#launcher {
  display: none;
}
</style>
